import { render, staticRenderFns } from "./addobjcalendar.vue?vue&type=template&id=6c8e25ef&scoped=true&"
import script from "./addobjcalendar.vue?vue&type=script&lang=js&"
export * from "./addobjcalendar.vue?vue&type=script&lang=js&"
import style0 from "./addobjcalendar.vue?vue&type=style&index=0&id=6c8e25ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e25ef",
  null
  
)

export default component.exports